/**
 * Configuration for mapping push payload keys to notification fields.
 * Written to the App Group so the NSE can read it at notification time.
 */
export type NotificationExtensionConfig = {
  /** Key path in the push payload for the sender's unique identifier (required). */
  senderIdKey: string;
  /** Key path in the push payload for the sender's avatar URL. */
  avatarUrlKey?: string;
  /** Key path in the push payload for the conversation/thread identifier. */
  conversationIdKey?: string;
  /** Key path in the push payload for the group name. */
  groupNameKey?: string;
  /** Key path in the push payload for the group avatar URL. */
  groupAvatarUrlKey?: string;
};

/**
 * Result of the validateSetup() diagnostic function.
 */
export type ValidationResult = {
  /** Whether the runtime config was found and is valid in the App Group. */
  configValid: boolean;
  /** Whether the App Group container is accessible for read/write. */
  appGroupAccessible: boolean;
  /** Number of avatars currently cached in the App Group. */
  cachedAvatarCount: number;
  /** If a sample payload was provided, the extracted fields. */
  payloadParseResult?: {
    senderId: string | null;
    avatarUrl: string | null;
    conversationId: string | null;
    groupName: string | null;
    groupAvatarUrl: string | null;
  };
};
